import React from 'react';
import './ServicesGrid.css';

interface ServiceItem {
  icon?: string;
  title: string;
  description?: string;
  highlights?: string[];
  subsections?: {
    title: string;
    items: string[];
    info?: string;
  }[];
}

interface ServicesGridProps {
  heading: string;
  services: ServiceItem[];
}

const ServicesGrid: React.FC<ServicesGridProps> = ({ heading, services }) => {
  return (
    <section className="services-grid-module" id="services">
      <div className="services-grid-container max-width">
        <div className="section-header reveal">
          <p className="section-pre-heading">EXPERIENCE & COMFORT</p>
          <h2 className="section-title">{heading}</h2>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card reveal">
              <div className="card-top">
                <div className="icon-wrapper">
                  <span className="service-icon">{service.icon}</span>
                </div>
                <h3 className="service-title">{service.title}</h3>
                {service.description && <p className="service-description">{service.description}</p>}
              </div>

              {service.highlights && (
                <ul className="highlights-list">
                  {service.highlights.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              )}

              {service.subsections && (
                <div className="subsections-container">
                  {service.subsections.map((sub, i) => (
                    <div key={i} className="service-subsection">
                      <h4 className="sub-title">{sub.title}</h4>
                      <ul className="sub-items">
                        {sub.items.map((item, j) => (
                          <li key={j}>{item}</li>
                        ))}
                      </ul>
                      {sub.info && <p className="sub-info">{sub.info}</p>}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
